import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	tagCard: {
		border: `1.5px solid ${colors.purple[100]}`,
		borderRadius: 14,
		padding: 16
	},
	tagCardHeader: {
		marginBottom: 10
	},
	tagIconBox: {
		width: 42,
		height: 42,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	tagEyebrow: {
		fontSize: "11.5px",
		fontWeight: 400,
		color: colors.purple[300],
		lineHeight: 1
	},
	tagName: {
		fontSize: 15,
		fontWeight: 800,
		color: colors.gray[800],
		lineHeight: 1.3
	},
	deleteButton: {
		width: 28,
		height: 28,
		borderRadius: 8,
		backgroundColor: colors.red[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		flexShrink: 0
	},
	tagContentColumn: {
		marginLeft: 52
	},
	descriptionText: {
		fontSize: "13.5px",
		fontWeight: 400,
		color: colors.gray[500],
		lineHeight: 1.4,
		marginTop: 4
	},
	warningRow: {
		marginTop: 4
	},
	warningIconBox: {
		display: "flex",
		alignItems: "center",
		flexShrink: 0
	},
	warningIcon: {
		color: colors.yellow[700],
		fontSize: 18
	},
	warningText: {
		fontSize: "13.5px",
		fontWeight: 400,
		color: colors.yellow[700],
		lineHeight: 1.4
	},
	editLink: {
		fontSize: "13.5px",
		fontWeight: 800,
		color: colors.blue[800],
		marginTop: 6,
		display: "inline-flex",
		alignItems: "center",
		cursor: "pointer"
	},
	editLinkIcon: {
		color: colors.blue[800],
		fontSize: 16,
		marginLeft: 4
	}
}))

export default useStyles
